import { render, staticRenderFns } from "./reportePtiRevision.vue?vue&type=template&id=c7c64240&scoped=true"
import script from "./reportePtiRevision.vue?vue&type=script&lang=js"
export * from "./reportePtiRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c64240",
  null
  
)

export default component.exports